import type { DataTableColumn } from "../../components/molecules/DataTable/DataTable.types";

export const buildCsvPreviewColumns = (
  columns: string[],
): DataTableColumn<Record<string, unknown>>[] =>
  columns.map((col, index) => ({
    key: col,
    header: col.toUpperCase(),
    bodyVariant: 4 as const,
    emphasis: index === 1 ? ("high" as const) : ("medium" as const),
    render: (row) => String(row[col] ?? ""),
  }));
